import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Cursor } from 'animal-island-ui';
import 'animal-island-ui/dist/index.css'; // Import style exactly once

import { NookPhone } from './components/NookPhone';
import { HomeScreen } from './pages/HomeScreen';
import { CalendarPage } from './pages/CalendarPage';
import { LogDetailPage } from './pages/LogDetailPage';
import { MapViewPage } from './pages/MapViewPage';
import { StatsPage } from './pages/StatsPage';
import { WizardPage } from './pages/WizardPage';
import { InstructionsPage } from './pages/InstructionsPage';
import './App.css';

export function App() {
  return (
    <Cursor>
      <Router>
        <div className="app-container">
          <NookPhone>
            <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/wizard" element={<WizardPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/meal/:id" element={<LogDetailPage />} />
              <Route path="/map" element={<MapViewPage />} />
              <Route path="/stats" element={<StatsPage />} />
              <Route path="/instructions" element={<InstructionsPage />} />
            </Routes>
          </NookPhone>
        </div>
      </Router>
    </Cursor>
  );
}
export default App;
